module.exports = __webpack_public_path__ + "f6fca54a6923057cfe641665f645a5e5.pdf";